import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { getUsefulTipsList } from '../../api/useful-tips'
import { GenericItemList, LoadMoreButton } from '../../components'
import { ENTRIES_PER_PAGE } from '../../constants'
import { useDocumentTitle } from '../../hooks'
import { NewsItem } from '../../interfaces'
import { useAppContextStore } from '../../store'

export const UsefulTipsList = () => {
  const { i18n } = useTranslation()
  const explanatoryTexts = useAppContextStore((state) => state.explanatoryTexts)

  useDocumentTitle(explanatoryTexts['useful-tips-title'])

  const [data, setData] = useState<NewsItem[]>()
  const [hasMore, setHasMore] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)

  const { isLoading } = useQuery<NewsItem[]>(
    ['useful-tips-list', currentPage],
    () => getUsefulTipsList(i18n.language, currentPage),
    {
      onSuccess: (response) => {
        setHasMore(response.length === ENTRIES_PER_PAGE)

        const nextList = (data || []).concat(response)

        setData(nextList)
      },
    }
  )

  const onLoadMore = () => {
    setCurrentPage(currentPage + 1)
  }

  return (
    <GenericItemList
      label={explanatoryTexts['useful-tips-title']}
      slug="/useful-tips/"
      isLoading={isLoading}
      data={data}
    >
      <LoadMoreButton hasMore={hasMore} isLoading={isLoading} onLoadMore={onLoadMore} />
    </GenericItemList>
  )
}
